import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { Row, Col, Modal } from 'react-bootstrap'
import { cartContainer } from 'src/models'
import { quickViewState } from 'src/views/components'
import Product from '../../Product'
import './styles.scss'

@observer
class BundleView extends React.Component {
  @observable productCount = 1

  handleQuickView = event => {
    event.preventDefault()
    const productId =
      this.props?.productId || this.props?.product || 'identifier'
    const categoryId = this.props?.categoryId || ''
    quickViewState.getProduct({ productId, categoryId })
  }

  handleSkuSelection = product => {
    quickViewState.updateSku(product)
  }

  handleQuantityChange = count => {
    this.productCount = count
  }

  getAddToBagParams = () => {
    const { skuId = '', productId = '' } = quickViewState.product
    const categoryId =
      quickViewState.productResponse?.category?.identifier || ''

    if (skuId) {
      return [
        {
          skuId,
          productId,
          quantity: this.productCount,
          categoryId: categoryId,
        },
      ]
    }
    return []
  }

  handleAddToBag = async () => {
    const cartArray = this.getAddToBagParams()

    if (cartArray) {
      const response = await cartContainer.addToCart({
        cartArray,
      })
      quickViewState.toggleQuickView()
      return response
    }
  }

  closeQuickView = () => {
    quickViewState.toggleQuickView()
  }

  render() {
    return (
      <Modal
        show={this.props.isBundleView}
        dialogClassName="modal-90w quick-view-dialog"
        onHide={this.props.handleBundleView}
        className="quick-view-modal">
        <Modal.Header className="border-0" closeButton />
        <Modal.Body>
          <Row noGutters className="position-relative">
            <Col className="px-2" sm={12} md={12}>
              <Product {...this.props} isBundleView={this.props.isBundleView} />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
}

export { BundleView }
export default BundleView
